import { apiRequest } from './client';

export function fetchProducts(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/products${query ? `?${query}` : ''}`, token);
}

export function fetchProductPriceChanges(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/products/price-changes${query ? `?${query}` : ''}`, token);
}

export function syncProducts(token, options = {}) {
  return apiRequest('/admin/products/sync', token, {
    method: 'POST',
    body: JSON.stringify({
      // Fast sync by default; images backfill in background + lazy-load in UI.
      includeCatalogImages: false,
      backfillImages: true,
      ...options,
    }),
  });
}

export function updateProductQuantity(token, listingId, quantity) {
  return apiRequest(`/admin/products/${listingId}/quantity`, token, {
    method: 'PATCH',
    body: JSON.stringify({ quantity }),
  });
}

export function resolveProductImage(token, asin, marketplace = 'IN') {
  const query = new URLSearchParams({ asin, marketplace }).toString();
  return apiRequest(`/admin/products/image?${query}`, token);
}
